"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _lodash = require("lodash");
var _src = require("@seedlang/utils/src");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var CardIconsWrapper = function CardIconsWrapper(Component) {
  var _class, _class2, _descriptor;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2() {
      var _this;
      _classCallCheck(this, _class2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, _class2, [].concat(args));
      _initializerDefineProperty(_this, "showActiveReviewIcon", _descriptor, _this);
      _this.createCardIconEvent = function (eventType) {
        var _this$props$card, _DeckUI$deck, _this$props$card2, _this$props$card3;
        _state.DeckUI.createEvent(eventType, {
          language_id: ((_this$props$card = _this.props.card) === null || _this$props$card === void 0 ? void 0 : _this$props$card.languageId) || ((_DeckUI$deck = _state.DeckUI.deck) === null || _DeckUI$deck === void 0 ? void 0 : _DeckUI$deck.languageId),
          card_type_id: ((_this$props$card2 = _this.props.card) === null || _this$props$card2 === void 0 || (_this$props$card2 = _this$props$card2.cardType) === null || _this$props$card2 === void 0 ? void 0 : _this$props$card2.id) || ((_this$props$card3 = _this.props.card) === null || _this$props$card3 === void 0 ? void 0 : _this$props$card3.cardTypeId)
        });
      };
      _this.createDeckCardActionEvent = function (eventType) {
        var _DeckUI$deck2, _DeckUI$deck3, _this$props$card4;
        _state.DeckUI.createEvent(eventType, {
          languageId: (_DeckUI$deck2 = _state.DeckUI.deck) === null || _DeckUI$deck2 === void 0 ? void 0 : _DeckUI$deck2.languageId,
          deckId: (_DeckUI$deck3 = _state.DeckUI.deck) === null || _DeckUI$deck3 === void 0 ? void 0 : _DeckUI$deck3.id,
          cardId: (_this$props$card4 = _this.props.card) === null || _this$props$card4 === void 0 ? void 0 : _this$props$card4.id
        });
      };
      _this.navigateNative = function (screen) {
        var _this$props$navigatio;
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (_this$props$navigatio = _this.props.navigation) === null || _this$props$navigatio === void 0 || _this$props$navigatio.navigate(screen, params);
      };
      _this.onToggleReview = function () {
        _this.showActiveReviewIcon = !_this.showActiveReviewIcon;
        _state.AppUI.designateUiElementAsSeen('reviewIconOnboarding');
        var reviewCard = _state.DeckUI.reviewCard(_this.props.card);
        _this.createCardIconEvent('deck - click bookmark icon');
        if ((0, _src.isPresent)(reviewCard)) {
          _state.DeckUI.onToggleReview(_this.props.card, reviewCard === null || reviewCard === void 0 ? void 0 : reviewCard.deckId);
        } else {
          _state.DeckUI.onToggleReview(_this.props.card, _state.AppUI.defaultReviewDeckId);
          if (_state.AppUI.user.reviewCardsCount < 100) {
            _state.DeckUI.setCardNotice({
              text: _state.AppUI.defaultReviewDeckName ? "Review added to ".concat(_state.AppUI.defaultReviewDeckName, "!") : 'Review added!',
              timeout: 3000
            });
          }
        }
      };
      _this.onToggleMicrophone = function () {
        _this.createCardIconEvent('deck - click microphone toggle icon');
        if (_state.DeckUI.layout.isNative && (0, _lodash.isFunction)(_state.DeckUI.nativeKeyboardDismiss)) {
          _state.DeckUI.nativeKeyboardDismiss();
        }
        var newValue = !_state.AppUI.user.vocabCardAudio;
        _state.AppUI.user.set('vocabCardAudio', newValue);
        _state.AppUI.authUserStore.update({
          data: {
            vocabCardAudio: newValue
          }
        }, _lodash.noop);
      };
      _this.onToggleMultipleChoice = function () {
        _this.createCardIconEvent('deck - click multiple choice toggle icon');
        if (_this.props.card.cardTypeSlug.startsWith('conjugation')) {
          var newValue = !_state.AppUI.user.textInputConjugationTrainer;
          _state.AppUI.user.set('textInputConjugationTrainer', newValue);
          _state.AppUI.authUserStore.update({
            data: {
              textInputConjugationTrainer: newValue
            }
          }, _lodash.noop);
        }
        if (_this.props.card.cardTypeSlug.startsWith('number')) {
          var _newValue = !_state.AppUI.user.textInputNumberTrainer;
          _state.AppUI.user.set('textInputNumberTrainer', _newValue);
          _state.AppUI.authUserStore.update({
            data: {
              textInputNumberTrainer: _newValue
            }
          }, _lodash.noop);
        }
        if (_this.props.card.cardTypeSlug.startsWith('case-fill-in-the-blanks')) {
          var _newValue2 = !_state.AppUI.user.textInputCaseTrainer;
          _state.AppUI.user.set('textInputCaseTrainer', _newValue2);
          _state.AppUI.designateUiElementAsSeen('toggleCaseInputMode');
          _state.AppUI.authUserStore.update({
            data: {
              textInputCaseTrainer: _newValue2
            }
          }, _lodash.noop);
        }
      };
      _this.onClickDeckGrammar = function () {
        _this.createCardIconEvent('deck - click deck grammar icon');
        if (_state.DeckUI.layout.isNative) {
          _this.navigateNative('DeckGrammar');
          return;
        }
        _state.DeckUI.gotoDeckGrammar();
      };
      _this.onClickConceptDescription = function () {
        _this.createCardIconEvent('deck - click concept description icon');
        if (_state.DeckUI.layout.isNative) {
          _this.navigateNative('ConceptDescription');
          return;
        }
        _state.DeckUI.gotoConceptDescription();
      };
      _this.onClickCardNote = function () {
        _this.createCardIconEvent('deck - click note icon');
        if (_state.DeckUI.layout.isNative) {
          _this.navigateNative('CardNote');
          _state.DeckUI.designateUiElementAsSeen('noteOnboarding');
          return;
        }
        _state.DeckUI.gotoCardNote(_this.props.card);
      };
      _this.onClickCardComments = function () {
        if (_state.DeckUI.layout.isNative) {
          _this.navigateNative('CardComments', {
            navigationTimeStamp: Date.now()
          });
          _state.DeckUI.designateUiElementAsSeen('commentOnboarding');
          _this.createDeckCardActionEvent('deck - view comments');
          return;
        }
        _state.DeckUI.gotoCardComments(_this.props.card);
      };
      _this.onClickGrammarTip = function () {
        if (_state.DeckUI.layout.isNative) {
          _this.navigateNative('GrammarTip', {
            navigationTimeStamp: Date.now()
          });
          _state.DeckUI.designateUiElementAsSeen('caseConcept');
          _this.createDeckCardActionEvent('deck - open grammar tip');
          return;
        }
        _state.DeckUI.gotoGrammarTip(_this.props.card);
      };
      _this.onClickReviewDetails = function () {
        _this.createCardIconEvent('deck - click review details icon');
        if (_state.DeckUI.layout.isNative) {
          var _this$props$card5;
          var cardId = (_this$props$card5 = _this.props.card) === null || _this$props$card5 === void 0 ? void 0 : _this$props$card5.id;
          if (!cardId) {
            return;
          }
          _this.navigateNative('ReviewDetails', {
            cardId: cardId,
            navigationTimeStamp: Date.now(),
            inDeck: true
          });
          return;
        }
        _state.DeckUI.gotoReviewDetails(_this.props.card);
      };
      _this.onClickVocabButton = function () {
        var _this$props$card6;
        if ((0, _src.isBlank)((_this$props$card6 = _this.props.card) === null || _this$props$card6 === void 0 ? void 0 : _this$props$card6.word)) {
          return;
        }
        _this.createCardIconEvent('deck - click vocab icon');
        if (_state.DeckUI.layout.isNative) {
          var wordStoreId = _state.AppUI.createWordStore(_this.props.card.word);
          _this.navigateNative('VocabCard', {
            wordId: _this.props.card.word.id,
            wordStoreId: wordStoreId,
            synonymAssociationId: _this.props.card.synonymAssociationId
          });
          _state.DeckUI.designateUiElementAsSeen('vocabCardOnboarding');
          return;
        }
        _state.DeckUI.gotoVocabCard(_this.props.card);
      };
      _this.onClickLanguageButton = function () {
        _this.createCardIconEvent('deck - click swap language icon');
        _this.props.cardState.toggleShowType();
      };
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "iconWidth",
      get: function get() {
        return _state.DeckUI.layout.minimumHeight ? 30 : 40;
      }
    }, {
      key: "iconRightPos",
      get: function get() {
        if (_state.DeckUI.layout.isMobile || _state.DeckUI.layout.minimumHeight) {
          return 15;
        }
        if (_state.DeckUI.layout.osName === 'Windows') {
          return 25;
        }
        return 20;
      }
    }, {
      key: "buttonText",
      get: function get() {
        return 'View Deck';
      }
    }, {
      key: "iconTop",
      value: function iconTop(index) {
        var iconHeight = _state.DeckUI.layout.minimumHeight ? 37 : 42;
        return 20 + iconHeight * index;
      }
    }, {
      key: "textInputTrainer",
      get: function get() {
        if (this.props.card.cardTypeSlug.startsWith('conjugation')) {
          return _state.AppUI.user.textInputConjugationTrainer;
        }
        if (this.props.card.cardTypeSlug.startsWith('number')) {
          return _state.AppUI.user.textInputNumberTrainer;
        }
        if (this.props.card.cardTypeSlug.startsWith('case-fill-in-the-blanks')) {
          return _state.AppUI.user.textInputCaseTrainer;
        }
      }
    }, {
      key: "reviewDetailsProgressSegments",
      get: function get() {
        var ratioBase = _state.AppUI.user.daysUntilReviewRetired;
        var ratioValue = this.props.card && this.props.card.repetitionInterval;
        if (!(0, _src.isPresent)(ratioValue)) {
          return 0;
        }
        if (!(ratioBase > 0)) {
          return 3;
        }
        var ratio = ratioValue / ratioBase;
        if (ratio >= 3 / 4) {
          return 3;
        }
        if (ratio >= 1 / 2) {
          return 2;
        }
        return 1;
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          card: this.props.card,
          cardState: this.props.cardState,
          userCard: this.props.userCard,
          iconWidth: this.iconWidth,
          iconRightPos: this.iconRightPos,
          buttonText: this.buttonText,
          icons: this.props.icons,
          iconTop: this.iconTop,
          onToggleReview: this.onToggleReview,
          onToggleMicrophone: this.onToggleMicrophone,
          onToggleMultipleChoice: this.onToggleMultipleChoice,
          onClickDeckGrammar: this.onClickDeckGrammar,
          onClickConceptDescription: this.onClickConceptDescription,
          onClickCardNote: this.onClickCardNote,
          onClickCardComments: this.onClickCardComments,
          onClickGrammarTip: this.onClickGrammarTip,
          onClickReviewDetails: this.onClickReviewDetails,
          onClickVocabButton: this.onClickVocabButton,
          onClickLanguageButton: this.onClickLanguageButton,
          textInputTrainer: this.textInputTrainer,
          showActiveReviewIcon: this.showActiveReviewIcon,
          reviewDetailsProgressSegments: this.reviewDetailsProgressSegments
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "showActiveReviewIcon", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return _state.DeckUI.reviewCard(this.props.card) ? true : false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "iconWidth", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "iconWidth"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "iconRightPos", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "iconRightPos"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "buttonText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "buttonText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "textInputTrainer", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "textInputTrainer"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "reviewDetailsProgressSegments", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "reviewDetailsProgressSegments"), _class2.prototype), _class2)) || _class;
};
CardIconsWrapper.displayName = 'CardIconsWrapper';
var _default = exports["default"] = CardIconsWrapper;